var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "right-arrow-7359",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.882,
    height: 8.286,
    viewBox: "0 0 15.882 8.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_68174",
    "data-name": "Path 68174",
    d: "M15.176,117.16H.706c-.39,0-.706-.437-.706-.975s.316-.975.706-.975h14.47c.39,0,.706.437.706.975S15.566,117.16,15.176,117.16Z",
    transform: "translate(0 -112.042)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_68175",
    "data-name": "Path 68175",
    d: "M194.884,86.987a.975.975,0,0,1-.689-1.665l2.478-2.478-2.478-2.478a.975.975,0,0,1,1.379-1.379l3.168,3.168a.975.975,0,0,1,0,1.379L195.574,86.7A.971.971,0,0,1,194.884,86.987Z",
    transform: "translate(-183.145 -78.701)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.b70e251a5530e48d03be9fa4138bb0fa.svg";
export { ForwardRef as ReactComponent };